import React, { useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderChatBoat from "./HeaderChatBoat";
import { useNavigate } from "react-router-dom";

function AdvisoryLocation() {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedCamp, setSelectedCamp] = useState("");
    const [selectedSpecies, setSelectedSpecies] = useState("");
    const [formSubmitted, setFormSubmitted] = useState(false);

    const navigate = useNavigate();


    // --- Sample Data ---
    const data = {
        Zambia: {
            regions: {
                region1: {
                    districts: {
                        "District A": {
                            camps: {
                                "Camp X": ["Species 1", "Species 2"],
                                "Camp Y": ["Species 3", "Species 4"],
                            },
                        },
                        "District B": {
                            camps: {
                                "Camp Z": ["Species 7", "Species 8"],
                            },
                        },
                    },
                },
                region2: {
                    districts: {
                        "District C": {
                            camps: {
                                "Camp W": ["Species 5", "Species 6"],
                            },
                        },
                    },
                },
            },
        },
        usa: {
            regions: {
                region1: {
                    districts: {
                        "District E": {
                            camps: {
                                "Camp Alpha": ["Eagle", "Bison"],
                                "Camp Beta": ["Wolf", "Fox"],
                            },
                        },
                    },
                },
                region2: {
                    districts: {
                        "District G": {
                            camps: {
                                "Camp Gamma": ["Bear", "Moose"],
                            },
                        },
                    },
                },
            },
        },
    };

    // --- Handlers ---
    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value);
        setSelectedRegion("");
        setSelectedDistrict("");
        setSelectedCamp("");
        setSelectedSpecies("");
    };

    const handleRegionChange = (e) => {
        setSelectedRegion(e.target.value);
        setSelectedDistrict("");
        setSelectedCamp("");
        setSelectedSpecies("");
    };

    const handleDistrictChange = (e) => {
        setSelectedDistrict(e.target.value);
        setSelectedCamp("");
        setSelectedSpecies("");
    };

    const handleCampChange = (e) => {
        setSelectedCamp(e.target.value);
        setSelectedSpecies("");
    };

    const handleSpeciesChange = (e) => {
        setSelectedSpecies(e.target.value);
    };

    const handleContinue = () => {
        if (
            selectedCountry &&
            selectedRegion &&
            selectedDistrict &&
            selectedCamp &&
            selectedSpecies
        ) {
            setFormSubmitted(true);
        } else {
            alert("⚠️ Please select all fields before continuing.");
        }
    };

    const handleEdit = () => {
        setFormSubmitted(false);
        navigate("/chat");
    };

    const handleRefresh = () => {
        setSelectedCountry("");
        setSelectedRegion("");
        setSelectedDistrict("");
        setSelectedCamp("");
        setSelectedSpecies("");
        setFormSubmitted(false);
    };

    return (
        <>
            <HeaderChatBoat />
            <section
                className="content-height"
                style={{ overflowY: "hidden", minHeight: "89vh" }}
            >
                <div className="d-flex flex-column mt-60px" style={{ height: "90vh" }}>
                    <Container fluid className="flex-grow-1 p-0">
                        <Row className="h-100 g-0">
                            {/* ---------- Fixed Sidebar ---------- */}
                            <div
                                className="border-end d-flex flex-column p-3"
                                style={{
                                    position: "fixed",
                                    top: "60px",
                                    left: 0,
                                    bottom: 0,
                                    width: sidebarOpen ? "350px" : "60px",
                                    transition: "width 0.3s ease",
                                    overflowY: "auto",
                                    background: "#F6F6F6",
                                    zIndex: 1000,
                                }}
                            >
                                {sidebarOpen && (
                                    <div className="d-flex flex-column gap-3 p-2">
                                        <div className="mt-4" style={{ maxWidth: "400px" }}>
                                            {/* Country */}
                                            <div className="form-group text-start mb-2">
                                                <label>
                                                    Select Country <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-select mt-1 h36px bg-transparent"
                                                    value={selectedCountry}
                                                    onChange={handleCountryChange}
                                                >
                                                    <option value="">Select Country</option>
                                                    {Object.keys(data).map((country) => (
                                                        <option key={country} value={country}>
                                                            {country.toUpperCase()}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Region */}
                                            {selectedCountry && (
                                                <div className="form-group text-start mb-2">
                                                    <label>
                                                        Select Region <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className="form-select mt-1 h36px bg-transparent"
                                                        value={selectedRegion}
                                                        onChange={handleRegionChange}
                                                    >
                                                        <option value="">Select Region</option>
                                                        {Object.keys(data[selectedCountry].regions).map(
                                                            (region) => (
                                                                <option key={region} value={region}>
                                                                    {region}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            )}

                                            {/* District */}
                                            {selectedRegion && (
                                                <div className="form-group text-start mb-2">
                                                    <label>
                                                        Select District{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className="form-select mt-1 h36px bg-transparent"
                                                        value={selectedDistrict}
                                                        onChange={handleDistrictChange}
                                                    >
                                                        <option value="">Select District</option>
                                                        {Object.keys(
                                                            data[selectedCountry].regions[selectedRegion]
                                                                .districts
                                                        ).map((district) => (
                                                            <option key={district} value={district}>
                                                                {district}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}

                                            {/* Camp */}
                                            {selectedDistrict && (
                                                <div className="form-group text-start mb-2">
                                                    <label>
                                                        Select Camp <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className="form-select mt-1 h36px bg-transparent"
                                                        value={selectedCamp}
                                                        onChange={handleCampChange}
                                                    >
                                                        <option value="">Select Camp</option>
                                                        {Object.keys(
                                                            data[selectedCountry].regions[selectedRegion]
                                                                .districts[selectedDistrict].camps
                                                        ).map((camp) => (
                                                            <option key={camp} value={camp}>
                                                                {camp}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}

                                            {/* Species */}
                                            {selectedCamp && (
                                                <div className="form-group text-start mb-2">
                                                    <label>
                                                        Select Species{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <select
                                                        className="form-select mt-1 h36px bg-transparent"
                                                        value={selectedSpecies}
                                                        onChange={handleSpeciesChange}
                                                    >
                                                        <option value="">Select Species</option>
                                                        {data[selectedCountry].regions[selectedRegion]
                                                            .districts[selectedDistrict].camps[
                                                            selectedCamp
                                                        ].map((sp) => (
                                                            <option key={sp}>{sp}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                        </div>

                                        {/* Buttons */}
                                        <div
                                            className="fixed-bottom mb-3 px-3"
                                            style={{ left: sidebarOpen ? "0" : "-9999px", maxWidth: '348px' }}
                                        >
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    <button
                                                        className="btn btn-refresh w-100"
                                                        onClick={handleRefresh}
                                                    >
                                                        Refresh
                                                    </button>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6">
                                                    {formSubmitted ? (
                                                        <button
                                                            className="btn btn-continue w-100"
                                                            onClick={handleEdit}
                                                        >
                                                            Edit
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="btn btn-continue  w-100"
                                                            onClick={handleContinue}
                                                        >
                                                            Continue
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <Button
                                    size="sm"
                                    onClick={toggleSidebar}
                                    className="position-absolute btn bg-transparent border-0"
                                    style={{
                                        right: "14px",
                                        top: "20px",
                                        borderRadius: "50%",
                                        zIndex: 5,
                                    }}
                                    title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
                                >
                                    <img src="/assets/images/Layout.png" height={20} alt="toggle" />
                                </Button>
                            </div>

                            {/* ---------- Main Chat Area ---------- */}
                            <Col
                                className="d-flex flex-column"
                                style={{
                                    marginLeft: sidebarOpen ? "350px" : "60px",
                                    transition: "margin-left 0.3s ease",
                                }}
                            >
                                <div
                                    className="flex-grow-1 p-3 overflow-auto"
                                    style={{ height: "72vh", overflowY: "scroll" }}
                                >
                                    {formSubmitted ? (
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                                <div className="px-5 pt-3">
                                                    <div className="card rightChatBox">
                                                        <div className="card-body h361px">
                                                            <div className="scrollBox">
                                                                <p>Generating Response for you....</p>
                                                            </div>
                                                        </div>

                                                        <div className="card-footer border-0">
                                                            <ul className="d-flex fixedFooterTool">
                                                                <li><img src="/assets/images/sound.png" /></li>
                                                                <li><img src="/assets/images/copy.png" /></li>
                                                                <li><img src="/assets/images/repeat.png" /></li>
                                                                <li><img src="/assets/images/thumbsdown.png" /></li>
                                                                <li><img src="/assets/images/magic.png" /></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="pt-3 userText">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-2 col-lg-2"></div>
                                                <div className="col-sm-12 col-md8 col-lg-8">
                                                    <div className="d-flex justify-content-start align-items-start">
                                                        <div>
                                                            <p className="mb-0 pe-2">
                                                                <img
                                                                    src="/assets/images/logo-chatboat.png" height={40}
                                                                    alt="Logo"
                                                                    className=""
                                                                />
                                                            </p>
                                                        </div>
                                                        <div>
                                                            <h4>Hello!</h4>
                                                            <h4>How can I assist you with Advisory today?</h4>
                                                            <p>Choose a prompt below or write your own to start chatting with Advisory</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Chat Box (Always Visible) */}
                                <div className="bg-white mx-100px">
                                    <div className="card">
                                        <div className="card-body p-0">
                                            <input
                                                type="text"
                                                className="form-control bg-white h42px border-0"
                                                placeholder="Ask me a question..."
                                            />
                                        </div>
                                        <div className="card-footer bg-white p-0">
                                            <div className="d-flex justify-content-between align-items-center p-1">
                                                <div>
                                                    <button className="btn btnActionButton me-3">
                                                        <span className="me-2">
                                                            <img src="/assets/images/message.png" alt="" />
                                                        </span>
                                                        Browse Prompts
                                                    </button>
                                                    <button className="btn btnActionButton me-3">
                                                        <span className="me-2">
                                                            <img src="/assets/images/attach.png" alt="" />
                                                        </span>
                                                        Attach
                                                    </button>
                                                    <button className="btn btnActionButton me-3">
                                                        <span className="me-2">
                                                            <img src="/assets/images/setting.png" alt="" />
                                                        </span>
                                                        Settings
                                                    </button>
                                                </div>
                                                <div>
                                                    <button className="btn btnActionButton p-0">
                                                        <img src="/assets/images/send.png" alt="send" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="mb-0 textError">
                                        Chatbot can make mistakes sometimes, please double check.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default AdvisoryLocation;
